<template>
    <div></div>
</template>

<script>
    import Highcharts from 'highcharts/highmaps';
    require('highcharts/modules/exporting')(Highcharts);
    import map from '../../maps/ireland';

    export default {
        data() {
            return {
                map: {},
                isHighMap: true,
            }
        },

        props: {
            title: {
                type: String,
            },

            dataset: {
                required: true,
                type: Array,
            },

            height: {
                type: Number,
            }
        },


        watch: {
            dataset() {
                this.map.destroy();
                this.draw();
            }
        },

        mounted() {
            bus.$on('update-charts', function () {
                this.map.destroy();
                this.draw();
            }.bind(this));

            this.draw();
        },

        computed: {
            chartHeight() {
                if (typeof this.height == 'undefined') return '';

                return this.height;
            },
        },

        methods: {
            draw() {
                this.map = Highcharts.mapChart(this.$el, {
                    title: {
                        text: ''
                    },

                    chart: {
                        height: this.chartHeight,
                    },

                    credits: {
                        enabled: false,
                    },

                    legend: {
                        enabled: false,
                    },

                    colorAxis: false,

                    exporting: {
                        enabled: false,
                    },

                    series: [{
                        mapData: map,
                        data: this.dataset,
                        name: 'Registrations',
                        states: {
                            hover: {
                                color: '#005daa'
                            }
                        },
                        dataLabels: {
                            enabled: false,
                            format: '{point.name}'
                        }
                    }]
                });
            },

            getSVG() {
                return this.map.getSVG();
            },
        }
    }
</script>